'use strict'

import $ from 'jquery'

export default class ThreeCTAs{
  constructor(el) {
    this.$el = $(el)
    this.cta = this.$el.find('.three-ctas__cta')
    this.next = this.$el.find('.three-ctas__next')
    this.prev = this.$el.find('.three-ctas__prev')
    const last = this.cta.length - 1

    // Assign first CTA as active slide for mobile
    $(this.cta[0]).addClass('active-cta')
    
    // Next Button
    this.next.on('click', (e)=>{
      if ($(this.cta[last]).hasClass('active-cta')) {
        $('.active-cta').removeClass('active-cta')
        $(this.cta[0]).addClass('active-cta')
      } else {
        $('.active-cta').removeClass('active-cta').next(this.cta).addClass('active-cta')
      }
    })

    // Prev Button
    this.prev.on('click', (e)=>{
      if ($(this.cta[0]).hasClass('active-cta')) {
        $('.active-cta').removeClass('active-cta')
        $(this.cta[last]).addClass('active-cta')
      } else {
        $('.active-cta').removeClass('active-cta').prev(this.cta).addClass('active-cta')
      }
    })
  } 
}
